import React from 'react';
import Timeslot from './Timeslot';
import { getWeekRange, getWeekTitle } from '../../utils/movieUtils';

const WeekView = ({ 
  week, 
  weekIndex,
  timeSlots,
  getScheduledMovieForSlot,
  isSlotOccupied,
  handleDragOver,
  handleDrop,
  removeScheduledMovie,
  setDraggedMovie,
  getStreamingServiceById
}) => {
  const dayHeaders = ['🕸️ Sun', '🦇 Mon', '👻 Tue', '🎃 Wed', '💀 Thu', '🧛 Fri', '🧟 Sat'];

  return (
    <div className="bg-gray-800 border-2 border-orange-600 rounded-lg shadow-2xl overflow-hidden mb-6">
      {/* Week Header */}
      <div className="bg-gray-900 border-b-2 border-orange-600 p-4">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-xl font-bold text-orange-300">
              {getWeekTitle(week, weekIndex)}
            </h3>
            <p className="text-orange-200 text-sm">
              {getWeekRange(week)}
            </p>
          </div>
          <div className="text-orange-400 text-sm">
            🪦 Horror Movie Marathon Schedule
          </div>
        </div>
      </div>

      {/* Calendar Days Header */}
      <div className="grid grid-cols-8 gap-0 bg-gray-900 border-b border-orange-500">
        <div className="p-3 text-center border-r border-orange-500">
          <div className="text-orange-400 text-sm font-bold">⏰ Time</div>
        </div>
        {dayHeaders.map((dayName, index) => (
          <div key={index} className="p-3 text-center border-r border-orange-500">
            <div className="text-orange-300 text-sm font-bold">{dayName}</div>
            <div className="text-orange-400 text-xs">
              {week[index].toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
            </div>
          </div>
        ))}
      </div>

      {/* Calendar Grid */}
      <div className="grid grid-cols-8 gap-0 min-h-0">
        {timeSlots.map((timeSlot, slotIndex) => (
          <React.Fragment key={timeSlot.id}>
            {/* Time Label */}
            <div className="bg-gray-900 border-r border-b border-orange-500 p-2 text-center">
              <div className="text-orange-400 text-xs font-bold">
                {timeSlot.time}
              </div>
            </div>
            
            {/* Day Cells */}
            {week.map((date, dayIndex) => {
              const scheduledMovie = getScheduledMovieForSlot(date, timeSlot);
              const isOccupied = isSlotOccupied(date, timeSlot);
              
              return (
                <Timeslot
                  key={`${dayIndex}-${slotIndex}`}
                  date={date}
                  timeSlot={timeSlot}
                  scheduledMovie={scheduledMovie}
                  isOccupied={isOccupied}
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                  onRemoveMovie={removeScheduledMovie}
                  onDragStart={setDraggedMovie}
                  getStreamingServiceById={getStreamingServiceById}
                />
              );
            })}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default WeekView;

